import React, { useState } from 'react'

export const ConsultationForm = () => {

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');

  return (
    <form>
        <div className="slope-contact-form">
            <div className="fields-wrapper">
                <div className="input-contact" style={{ width: '100%' }}>
                    <span className="name-field" style={{ width: '100%' }}>
                        <input
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            type="text"
                            name="name-field"
                            placeholder="Full Name *"
                            style={{ width: '100%' }}
                        />
                    </span>

                    <span className="email-field" style={{ width: '100%' }}>
                        <input
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            type="email"
                            name="email-field"
                            size="40"
                            placeholder="Email address *"
                            style={{ width: '100%' }}
                        />
                    </span>

                    <span className="number-field" style={{ width: '100%' }}>
                        <input
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            type="tel"
                            name="number-field" 
                            placeholder="Phone Number *"
                            style={{ width: '100%' }}
                        />
                    </span>
                </div>
                <div className="textarea-contact" style={{ width: '100%' }}>
                    <span className="message-field" style={{ width: '100%' }}>
                        <textarea
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            name="message-field"
                            placeholder="Message *"
                            style={{ width: '100%' }}
                        ></textarea>
                    </span>
                </div>
            </div>
            <div className="submit-contact">
                <input type="submit" value="Send Message" />
            </div>
        </div>
    </form>
  )
}
